import { createRemoteComponent } from '@module-federation/bridge-react';
import {
  loadRemote,
  registerRemotes,
} from '@module-federation/enhanced/runtime';
import { getRemote, Remote } from '@teamworksdev/web-sdk/module-federation';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { environment } from '../../../environment';
import { ContactSupportButton } from '../../components/button/ContactSupportButton';
import RemoteAppContainerError from '../../components/error/RemoteAppContainerError';
import { MFELoading } from '../../components/loading/MFELoading';

const loadMessaging = async ({ force }: { force?: boolean } = {}) => {
  registerRemotes(
    [
      getRemote(
        environment.VITE_ENVIRONMENT === 'production'
          ? 'production'
          : 'staging',
        environment.VITE_REGION,
        'messaging',
      ) as Remote,
    ],
    {
      force,
    },
  );

  return loadRemote('messaging/export-app');
};

type UnityMessagingMFEProps = {
  basename: string;
};

const MessagingLoadFallback = ({ error }: { error: Error }) => {
  const { t } = useTranslation();
  return (
    <RemoteAppContainerError
      refresh={() => loadMessaging({ force: true }).then(() => error)}
      failureHeader={t('messagingLoadFailureHeader')}
      failureDescription={t('messagingLoadFailureBody')}
      secondaryAction={<ContactSupportButton />}
    />
  );
};

const MessagingMFE = createRemoteComponent({
  fallback: (props) => <MessagingLoadFallback {...props} />,
  loader: () => loadMessaging(),
  loading: <MFELoading />,
}) as unknown as ComponentType<UnityMessagingMFEProps & { className?: string }>;

export const UnityMessagingMFE: ComponentType<UnityMessagingMFEProps> = (
  props,
) => {
  return <MessagingMFE {...props} className="flex-1 min-h-0 flex flex-col" />;
};
